<template>
  <div>
    <div class="child-bg-image">
      <div class="bg-image-section" />
      <div class="content-section">
        <check-out-page />
      </div>
    </div>
  </div>
</template>

<script>
  import CheckOutPage from '../Components/CheckOutPage.vue';
  export default {
    name: 'CheckOut',
    components: {
      'check-out-page': CheckOutPage,
    },
  };
</script>

<style scoped>
.content-section {
  padding: 0 !important;
}
</style>
